(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ApiSwitcher", [], factory);
	else if(typeof exports === 'object')
		exports["ApiSwitcher"] = factory();
	else
		root["ApiSwitcher"] = factory();
})(this, () => {
return 